import React, { useState } from "react";
import ReactDOM from "react-dom";
import { RegionItem, SelectItem, DiscountsItem } from "@t8891/pc-v1";
import ScrollLoad from "@Components/common/ScrollLoad";
import AskPriceModal from "@Components/buyCar/AskPriceModal";
import KindSumNav from "@Components/agent/KindSumNav";
import { gaEvent } from "@Lib/ga";
import { Common } from "@Api";
import { fetchSaleLeadsAgentDiscounts } from "@Services/api";
import "@Styles/global.less";
import styles from "./discounts.module.less";
const { regions } = Common;

import { QueryClient, useQuery, QueryClientProvider } from "react-query";
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

interface IProps {}

const { DiscountsTwo } = DiscountsItem;

const Item: any = ({
  setVisible,
  setData,
  discounts,
  agent,
  countdown,
  packageValue,
  id,
  totalPrice,
  activityPrice,
  type
}) => {
  return (
    <DiscountsTwo
      className={styles["discount-two-item"]}
      packageValue={packageValue}
      region={`${type === 'roster' ? "" : `${agent.showroom.regionName}業代提供`}`}
      discounts={discounts}
      countdown={countdown}
      onClick={() => {
        gaEvent("銷售線索", "綜述頁-優惠列表", "領取優惠");

        if (type === 'roster') {
          window.open(`/ask/price?b=${window.brandId}&k=${window.kindId}&source=綜述-領優惠`, "_blank");
          return
        }

        setVisible(true);
        setData({
          id: id,
          regionName: agent.showroom.regionName,
          regionId: agent.showroom.regionId,
          countdown,
          countdown,
          packageValue,
          packageValue,
          totalPrice: totalPrice,
          activityPrice: activityPrice,
        });
      }}
    />
  );
};

const Discounts: React.FC<IProps> = () => {
  const [item, setItem] = useState({ id: -1, name: "" });
  const [active, setActive] = useState(false);
  const [total, setTotal] = useState({
    total: 0,
    totalPrice: "",
  });
  const [visible, setVisible] = useState(false);
  const [discountData, setData] = useState({
    id: 0,
    regionId: "",
    countdown: "",
    packageValue: "",
    regionName: "",
    totalPrice: "",
    activityPrice: "",
  });

  const {
    data = {
      list: [],
      hot: [],
      selectedIndex: 0,
    },
  } = useQuery("regionsDiscounts", async () => {
    const res = await regions({
      kindId: window.kindId,
      type: "agentDiscount",
    });

    if (res?.status === 12000) {
      setItem({ id: res.data?.selectedId, name: "" });
      return res.data;
    }
  });

  return (
    <section className={styles["discounts"]}>
      <KindSumNav kindId={window.kindId} />
      <AskPriceModal
        visible={visible}
        setVisible={setVisible}
        brandId={window.brandId}
        data={discountData}
        kindId={window.kindId}
      />
      <SelectItem
        size='small'
        active={active}
        selected={item}
        data={data.hot}
        title='地區'
        onActive={() => setActive(!active)}
        onClick={(props) => {
          setItem(props);
        }}
      >
        <div>
          <RegionItem
            size='small'
            data={data.list}
            onClick={(props) => {
              setActive(false);
              setItem(props);
            }}
          />
        </div>
      </SelectItem>
      <div className={styles["discounts-title"]}>
        共找到
        <span className={styles["discounts-total"]}>{total.total}</span>
        個優惠禮包
      </div>
      {
        <div className={styles["discounts-main"]}>
          <ScrollLoad
            request={fetchSaleLeadsAgentDiscounts}
            params={{ k: window.kindId, region: item.id }}
            cache={`discounts-content-${item.id}`}
            callback={(data) => {
              setTotal(data);
            }}
          >
            <Item setData={setData} setVisible={setVisible} />
          </ScrollLoad>
        </div>
      }
    </section>
  );
};

const $webDiscounts = document.getElementById("web-discounts");

if (!!$webDiscounts) {
  ReactDOM.render(
    <QueryClientProvider client={queryClient}>
      <Discounts />
    </QueryClientProvider>,
    $webDiscounts,
  );
}
